import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-stack">
      @for (toast of toastService.toasts(); track toast.id) {
        <div class="toast show mb-2 border-0 shadow" role="alert">
          <div class="toast-header bg-{{ toast.variant || 'info' }} text-white">
            <strong class="me-auto">{{ toast.title }}</strong>
            <button type="button" class="btn-close btn-close-white" (click)="toastService.dismiss(toast.id)"></button>
          </div>
          @if (toast.body) {
            <div class="toast-body">{{ toast.body }}</div>
          }
        </div>
      }
    </div>
  `,
})
export class ToastHostComponent {
  protected readonly toastService = inject(ToastService);
}
